module.exports = __webpack_public_path__ + "static/img/image.2757e320.png";